import styled from 'styled-components';

export const HeadingAndFilterCon = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 0px 20px;
  gap: 20px;
  width: 100%;
  border-bottom: 1px solid var(--Foundation-Grey-grey-100, #d6d6d6);
`;

export const SharedResponseMainContainer = styled.div`
  display: flex;
  // align-items: center;
  flex-direction: row;
  background-color: #ffffff;
  border: 1px none;
  position: relative;
`;
export const SharedResponseContainer = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
`;
